"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadDocumentV2 = exports.uploadDocument = exports.updateHeloc = exports.setPlaidAssetsLinked = exports.sendEmployerVerification = exports.saveReview = exports.saveReason = exports.savePropertyV2 = exports.saveProperty = exports.saveProduct = exports.savePayType = exports.saveManualPaystubData = exports.saveInsurance = exports.saveIncomeVerificationRequest = exports.saveIncomeSource = exports.saveHmda = exports.saveHelocV2 = exports.saveHeloc = exports.saveFrozenPin = exports.saveDisburseAchPlaid = exports.saveDisburseAch = exports.saveConsents = exports.saveConsent = exports.saveAutopayAch = exports.saveAssetDepletion = exports.plCrossSell = exports.giactAccountVerification = exports.getUserHelocs = exports.getMaritalStatuses = exports.getIneligibleZipCodes = exports.getHelocStates = exports.getHeloc = exports.getCustomerRelationships = exports.getCountryCodes = exports.getConsentTypes = exports.confirmOffer = exports.bypassIDVerification = exports.activateHeloc = exports.UPLOAD_DOCUMENT_V2 = exports.UPLOAD_DOCUMENT = exports.UPDATE_HELOC = exports.SET_PLAID_ASSETS_LINKED = exports.SEND_EMPLOYER_VERIFICATION = exports.SAVE_REVIEW = exports.SAVE_REASON = exports.SAVE_PROPERTY_V2 = exports.SAVE_PROPERTY = exports.SAVE_PRODUCT = exports.SAVE_PAY_TYPE = exports.SAVE_MANUAL_PAYSTUB_DATA = exports.SAVE_INSURANCE = exports.SAVE_INCOME_VERIFICATION_REQUEST = exports.SAVE_INCOME_SOURCE = exports.SAVE_HMDA = exports.SAVE_HELOC_V2 = exports.SAVE_HELOC = exports.SAVE_FROZEN_PIN = exports.SAVE_DISBURSE_ACH_PLAID = exports.SAVE_DISBURSE_ACH = exports.SAVE_CONSENT_LIST = exports.SAVE_CONSENT = exports.SAVE_AUTOPAY_ACH = exports.SAVE_ASSET_DEPLETION = exports.PL_CROSS_SELL = exports.GIACT_ACCOUNT_VERIFICATION = exports.GET_USER_HELOCS = exports.GET_MARITAL_STATUSES = exports.GET_INELIGIBLE_ZIP_CODES = exports.GET_HELOC = exports.GET_ELIGIBLE_STATES = exports.GET_CUSTOMER_RELATIONSHIPS = exports.GET_COUNTRY_CODES = exports.GET_CONSENT_TYPES = exports.CONFIRM_OFFER = exports.BYPASS_ID_VERIFICATION = exports.ACTIVATE_HELOC = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxActions = require("redux-actions");

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var _env = require("../env");

var ACTIVATE_HELOC = 'HELOC::ACTIVATE';
exports.ACTIVATE_HELOC = ACTIVATE_HELOC;
var GET_MARITAL_STATUSES = 'HELOC::GET_MARITAL_STATUSES';
exports.GET_MARITAL_STATUSES = GET_MARITAL_STATUSES;
var GET_CONSENT_TYPES = 'HELOC::GET_CONSENT_TYPES';
exports.GET_CONSENT_TYPES = GET_CONSENT_TYPES;
var GET_CUSTOMER_RELATIONSHIPS = 'HELOC::GET_CUSTOMER_RELATIONSHIPS';
exports.GET_CUSTOMER_RELATIONSHIPS = GET_CUSTOMER_RELATIONSHIPS;
var GET_HELOC = 'HELOC::GET';
exports.GET_HELOC = GET_HELOC;
var GET_USER_HELOCS = 'HELOC::GET_USER';
exports.GET_USER_HELOCS = GET_USER_HELOCS;
var GET_COUNTRY_CODES = 'HELOC::GET_COUNTRY_CODES';
exports.GET_COUNTRY_CODES = GET_COUNTRY_CODES;
var SAVE_HELOC = 'SAVE_HELOC';
exports.SAVE_HELOC = SAVE_HELOC;
var SAVE_HELOC_V2 = 'SAVE_HELOC_V2';
exports.SAVE_HELOC_V2 = SAVE_HELOC_V2;
var SAVE_ASSET_DEPLETION = 'HELOC::SAVE_ASSET_DEPLETION';
exports.SAVE_ASSET_DEPLETION = SAVE_ASSET_DEPLETION;
var UPDATE_HELOC = 'HELOC::UPDATE';
exports.UPDATE_HELOC = UPDATE_HELOC;
var SAVE_FROZEN_PIN = 'HELOC::SAVE_FROZEN_PIN';
exports.SAVE_FROZEN_PIN = SAVE_FROZEN_PIN;
var SAVE_PRODUCT = 'HELOC::SAVE_PRODUCT';
exports.SAVE_PRODUCT = SAVE_PRODUCT;
var SAVE_PAY_TYPE = 'HELOC::SAVE_PAY_TYPE';
exports.SAVE_PAY_TYPE = SAVE_PAY_TYPE;
var SAVE_CONSENT = 'HELOC::SAVE_CONSENT';
exports.SAVE_CONSENT = SAVE_CONSENT;
var SAVE_CONSENT_LIST = 'HELOC::SAVE_CONSENT_LIST';
exports.SAVE_CONSENT_LIST = SAVE_CONSENT_LIST;
var SAVE_REASON = 'HELOC::SAVE_REASON';
exports.SAVE_REASON = SAVE_REASON;
var SAVE_HMDA = 'HELOC::SAVE_HMDA';
exports.SAVE_HMDA = SAVE_HMDA;
var SEND_EMPLOYER_VERIFICATION = 'HELOC::SEND_EMPLOYER_VERIFICATION';
exports.SEND_EMPLOYER_VERIFICATION = SEND_EMPLOYER_VERIFICATION;
var SAVE_PROPERTY_V2 = 'HELOC::SAVE_PROPERTY_V2';
/**
 * @deprecated No longer used
 */

exports.SAVE_PROPERTY_V2 = SAVE_PROPERTY_V2;
var SAVE_INCOME_VERIFICATION_REQUEST = 'HELOC::SAVE_INCOME_VERIFICATION_REQUEST';
exports.SAVE_INCOME_VERIFICATION_REQUEST = SAVE_INCOME_VERIFICATION_REQUEST;
var SAVE_DISBURSE_ACH = 'HELOC::SAVE_DISBURSE_ACH';
exports.SAVE_DISBURSE_ACH = SAVE_DISBURSE_ACH;
var SAVE_DISBURSE_ACH_PLAID = 'HELOC::SAVE_DISBURSE_ACH_PLAID';
exports.SAVE_DISBURSE_ACH_PLAID = SAVE_DISBURSE_ACH_PLAID;
var SAVE_AUTOPAY_ACH = 'HELOC::SAVE_AUTOPAY_ACH';
exports.SAVE_AUTOPAY_ACH = SAVE_AUTOPAY_ACH;
var SAVE_REVIEW = 'HELOC::SAVE_REVIEW';
exports.SAVE_REVIEW = SAVE_REVIEW;
var SAVE_INSURANCE = 'HELOC::SAVE_INSURANCE';
exports.SAVE_INSURANCE = SAVE_INSURANCE;
var SAVE_INCOME_SOURCE = 'HELOC::SAVE_INCOME_SOURCE';
exports.SAVE_INCOME_SOURCE = SAVE_INCOME_SOURCE;
var UPLOAD_DOCUMENT = 'HELOC::UPLOAD_DOCUMENT';
exports.UPLOAD_DOCUMENT = UPLOAD_DOCUMENT;
var UPLOAD_DOCUMENT_V2 = 'HELOC::UPLOAD_DOCUMENT_V2';
exports.UPLOAD_DOCUMENT_V2 = UPLOAD_DOCUMENT_V2;
var SET_PLAID_ASSETS_LINKED = 'HELOC::SET_PLAID_ASSETS_LINKED';
exports.SET_PLAID_ASSETS_LINKED = SET_PLAID_ASSETS_LINKED;
var GET_ELIGIBLE_STATES = 'HELOC::GET_ELIGIBLE_STATES';
exports.GET_ELIGIBLE_STATES = GET_ELIGIBLE_STATES;
var GET_INELIGIBLE_ZIP_CODES = 'HELOC::GET_INELIGIBLE_ZIP_CODES';
exports.GET_INELIGIBLE_ZIP_CODES = GET_INELIGIBLE_ZIP_CODES;
var SAVE_MANUAL_PAYSTUB_DATA = 'HELOC::SAVE_MANUAL_PAYSTUB_DATA';
exports.SAVE_MANUAL_PAYSTUB_DATA = SAVE_MANUAL_PAYSTUB_DATA;
var GIACT_ACCOUNT_VERIFICATION = 'HELOC::GIACT_ACCOUNT_VERIFICATION';
exports.GIACT_ACCOUNT_VERIFICATION = GIACT_ACCOUNT_VERIFICATION;
var PL_CROSS_SELL = 'HELOC::PL_CROSS_SELL';
exports.PL_CROSS_SELL = PL_CROSS_SELL;
var BYPASS_ID_VERIFICATION = 'HELOC::BYPASS_ID_VERIFICATION';
exports.BYPASS_ID_VERIFICATION = BYPASS_ID_VERIFICATION;
var SAVE_PROPERTY = 'HELOC::SAVE_PROPERTY';
exports.SAVE_PROPERTY = SAVE_PROPERTY;
var CONFIRM_OFFER = 'HELOC::CONFIRM_OFFER';
exports.CONFIRM_OFFER = CONFIRM_OFFER;
var HELOC_CONTEXT = '/service-application/api/v1/application/heloc';
var CONTEXT = _env.isMerchant ? '/app-merloc/secure/api/v1/application/heloc' : HELOC_CONTEXT;
var HELOC_CONTEXT_V2 = '/service-application/api/v2/application/heloc';
var activateHeloc = (0, _reduxActions.createAction)(ACTIVATE_HELOC);
exports.activateHeloc = activateHeloc;

var getMaritalStatuses = function getMaritalStatuses(primaryState, secondaryState) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_MARITAL_STATUSES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/marital-statuses?primaryState=").concat(primaryState).concat(secondaryState ? "&secondaryState=".concat(secondaryState) : '')));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getMaritalStatuses = getMaritalStatuses;

var getConsentTypes = function getConsentTypes() {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxGet)(GET_CONSENT_TYPES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/consent-types")));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.getConsentTypes = getConsentTypes;

var getCustomerRelationships = function getCustomerRelationships(state) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxGet)(GET_CUSTOMER_RELATIONSHIPS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/property/customer-relationship?state=").concat(state)));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.getCustomerRelationships = getCustomerRelationships;

var getHeloc = function getHeloc(uuid) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxGet)(GET_HELOC, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(uuid)));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.getHeloc = getHeloc;

var getUserHelocs = function getUserHelocs() {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", (0, _ajax.ajaxGet)(GET_USER_HELOCS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(HELOC_CONTEXT, "/all")));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.getUserHelocs = getUserHelocs;

var getCountryCodes = function getCountryCodes() {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", (0, _ajax.ajaxGet)(GET_COUNTRY_CODES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/country-codes")));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
}; // optionally promoCode & leadUuid


exports.getCountryCodes = getCountryCodes;

var saveHeloc = function saveHeloc(data) {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(dispatch) {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", (0, _ajax.ajaxPost)(SAVE_HELOC, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT), data));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
/**
 * saveHelocV2 was added to account for 'state' verification on the backend when starting a new HELOC.
 * saveHeloc calls: i.e. promo will not be affected
 */


exports.saveHeloc = saveHeloc;

var saveHelocV2 = function saveHelocV2(_ref8) {
  var data = _ref8.data,
      state = _ref8.state;
  return /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(dispatch) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", (0, _ajax.ajaxPost)(SAVE_HELOC_V2, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(HELOC_CONTEXT_V2, "?state=").concat(state), data));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref9.apply(this, arguments);
    };
  }();
};

exports.saveHelocV2 = saveHelocV2;

var updateHeloc = function updateHeloc(data) {
  return /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(dispatch) {
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", (0, _ajax.ajaxPut)(UPDATE_HELOC, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT), data));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref10.apply(this, arguments);
    };
  }();
}; // { helocUuid, pin }


exports.updateHeloc = updateHeloc;

var saveFrozenPin = function saveFrozenPin(data) {
  return /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(dispatch) {
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", (0, _ajax.ajaxPut)(SAVE_FROZEN_PIN, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/frozen-pin"), data));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref11.apply(this, arguments);
    };
  }();
}; // { helocUuid, amount, baseRate, primeRate, term, rateType, payType }


exports.saveFrozenPin = saveFrozenPin;

var saveProduct = function saveProduct(data) {
  return /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(dispatch) {
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", (0, _ajax.ajaxPut)(SAVE_PRODUCT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/product"), data));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x11) {
      return _ref12.apply(this, arguments);
    };
  }();
}; // { helocUuid, payType }


exports.saveProduct = saveProduct;

var savePayType = function savePayType(data) {
  return /*#__PURE__*/function () {
    var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(dispatch) {
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", (0, _ajax.ajaxPut)(SAVE_PAY_TYPE, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/pay-type"), data));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function (_x12) {
      return _ref13.apply(this, arguments);
    };
  }();
};

exports.savePayType = savePayType;

var saveProperty = function saveProperty(data) {
  return /*#__PURE__*/function () {
    var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(dispatch) {
      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", (0, _ajax.ajaxPut)(SAVE_PROPERTY, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/property"), data));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function (_x13) {
      return _ref14.apply(this, arguments);
    };
  }();
};

exports.saveProperty = saveProperty;

var savePropertyV2 = function savePropertyV2(data) {
  return /*#__PURE__*/function () {
    var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(dispatch) {
      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", (0, _ajax.ajaxPut)(SAVE_PROPERTY_V2, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(HELOC_CONTEXT_V2, "/property"), data));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function (_x14) {
      return _ref15.apply(this, arguments);
    };
  }();
};

exports.savePropertyV2 = savePropertyV2;

var saveConsent = function saveConsent(data) {
  return /*#__PURE__*/function () {
    var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(dispatch) {
      return _regenerator.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", (0, _ajax.ajaxPut)(SAVE_CONSENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/consent"), data));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function (_x15) {
      return _ref16.apply(this, arguments);
    };
  }();
};

exports.saveConsent = saveConsent;

var saveConsents = function saveConsents(data) {
  return /*#__PURE__*/function () {
    var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(dispatch) {
      return _regenerator.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", (0, _ajax.ajaxPut)(SAVE_CONSENT_LIST, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/consent-list"), data));

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function (_x16) {
      return _ref17.apply(this, arguments);
    };
  }();
};

exports.saveConsents = saveConsents;

var saveReason = function saveReason(data) {
  return /*#__PURE__*/function () {
    var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(dispatch) {
      return _regenerator.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", (0, _ajax.ajaxPut)(SAVE_REASON, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/reason"), data));

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function (_x17) {
      return _ref18.apply(this, arguments);
    };
  }();
}; // { helocUuid, retirement?, savings?, investment? }


exports.saveReason = saveReason;

var saveAssetDepletion = function saveAssetDepletion(data) {
  return /*#__PURE__*/function () {
    var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(dispatch) {
      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", (0, _ajax.ajaxPut)(SAVE_ASSET_DEPLETION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/asset-depletion"), data));

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    return function (_x18) {
      return _ref19.apply(this, arguments);
    };
  }();
}; // { helocUuid, type: PLAID|POINTSERV }

/**
 * @deprecated No longer used
 */


exports.saveAssetDepletion = saveAssetDepletion;

var saveIncomeVerificationRequest = function saveIncomeVerificationRequest(data) {
  return /*#__PURE__*/function () {
    var _ref20 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(dispatch) {
      return _regenerator.default.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", (0, _ajax.ajaxPut)(SAVE_INCOME_VERIFICATION_REQUEST, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/income-verification"), data));

            case 1:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    return function (_x19) {
      return _ref20.apply(this, arguments);
    };
  }();
};
/**
 * Saves updated account and routing numbers for a disbursement account.  This is used in the event that we didn't get the fully
 * qualified account or routing number from Plaid and need to allow the user to update it manually.
 * @param {Object} data Updated ACH data object including keys:
 *   - {String} helocUuid: The UUID for the HELOC application to update.
 *   - {String} accountNumber: The updated ACH account number (must match last four of existing masked account number).
 *   - {String} routingNumber: The updated ACH routing number.
 *   - {String} achAccountId: The Plaid account ID.
 */


exports.saveIncomeVerificationRequest = saveIncomeVerificationRequest;

var saveDisburseAch = function saveDisburseAch(data) {
  return /*#__PURE__*/function () {
    var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(dispatch) {
      return _regenerator.default.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", (0, _ajax.ajaxPut)(SAVE_DISBURSE_ACH, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/ach"), data));

            case 1:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    return function (_x20) {
      return _ref21.apply(this, arguments);
    };
  }();
}; // { helocUuid, accountType?, achAccountId }


exports.saveDisburseAch = saveDisburseAch;

var saveDisburseAchPlaid = function saveDisburseAchPlaid(data) {
  return /*#__PURE__*/function () {
    var _ref22 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(dispatch) {
      return _regenerator.default.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              return _context21.abrupt("return", (0, _ajax.ajaxPut)(SAVE_DISBURSE_ACH, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/ach/plaid"), data));

            case 1:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }));

    return function (_x21) {
      return _ref22.apply(this, arguments);
    };
  }();
}; // { helocUuid, uuid }


exports.saveDisburseAchPlaid = saveDisburseAchPlaid;

var saveAutopayAch = function saveAutopayAch(data) {
  return /*#__PURE__*/function () {
    var _ref23 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(dispatch) {
      return _regenerator.default.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              return _context22.abrupt("return", (0, _ajax.ajaxPut)(SAVE_AUTOPAY_ACH, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/ach/autopay"), data));

            case 1:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }));

    return function (_x22) {
      return _ref23.apply(this, arguments);
    };
  }();
}; // { helocUuid, accept }

/**
 * @deprecated No longer used
 */


exports.saveAutopayAch = saveAutopayAch;

var saveReview = function saveReview(data) {
  return /*#__PURE__*/function () {
    var _ref24 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(dispatch) {
      return _regenerator.default.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              return _context23.abrupt("return", (0, _ajax.ajaxPut)(SAVE_REVIEW, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/review"), data));

            case 1:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }));

    return function (_x23) {
      return _ref24.apply(this, arguments);
    };
  }();
}; // { helocUuid, floodInsured, homeownersInsured }


exports.saveReview = saveReview;

var saveInsurance = function saveInsurance(data) {
  return /*#__PURE__*/function () {
    var _ref25 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee24(dispatch) {
      return _regenerator.default.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              return _context24.abrupt("return", (0, _ajax.ajaxPut)(SAVE_INSURANCE, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/insurance"), data));

            case 1:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }));

    return function (_x24) {
      return _ref25.apply(this, arguments);
    };
  }();
}; // { helocUuid, uuid, employer, amount, employmentType, employerAddress: { city, state, zip } }


exports.saveInsurance = saveInsurance;

var saveIncomeSource = function saveIncomeSource(data) {
  return /*#__PURE__*/function () {
    var _ref26 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee25(dispatch) {
      return _regenerator.default.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              return _context25.abrupt("return", (0, _ajax.ajaxPut)(SAVE_INCOME_SOURCE, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/income-sources"), data));

            case 1:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25);
    }));

    return function (_x25) {
      return _ref26.apply(this, arguments);
    };
  }();
}; // HmdaRequest { helocUuid, ethnicity, race, gender }


exports.saveIncomeSource = saveIncomeSource;

var saveHmda = function saveHmda(data) {
  return /*#__PURE__*/function () {
    var _ref27 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee26(dispatch) {
      return _regenerator.default.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              return _context26.abrupt("return", (0, _ajax.ajaxPut)(SAVE_HMDA, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/hmda"), data));

            case 1:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }));

    return function (_x26) {
      return _ref27.apply(this, arguments);
    };
  }();
}; // { uuid, type, file, countryCode = null }


exports.saveHmda = saveHmda;

var uploadDocument = function uploadDocument(data, onProgress) {
  return /*#__PURE__*/function () {
    var _ref28 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee27(dispatch) {
      var form;
      return _regenerator.default.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              form = new FormData(); // eslint-disable-line new-cap

              form.append('uuid', data.uuid);
              form.append('type', data.type);
              form.append('file', data.file);
              if (data.countryCode) form.append('countryCode', data.countryCode);
              return _context27.abrupt("return", (0, _ajax.formPost)(UPLOAD_DOCUMENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/document"), form, data, onProgress));

            case 6:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }));

    return function (_x27) {
      return _ref28.apply(this, arguments);
    };
  }();
};
/** This endpoint is used solely to get the doc info back from an upload to fido.
 *  It does not return the full heloc object, and is not handled in the reducer.
 *  If you need/want to update heloc state use the other uploadDocument fn */


exports.uploadDocument = uploadDocument;

var uploadDocumentV2 = function uploadDocumentV2(data, onProgress) {
  return /*#__PURE__*/function () {
    var _ref29 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee28(dispatch) {
      var form;
      return _regenerator.default.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              form = new FormData(); // eslint-disable-line new-cap

              form.append('uuid', data.uuid);
              form.append('type', data.type);
              form.append('file', data.file);
              if (data.countryCode) form.append('countryCode', data.countryCode);
              return _context28.abrupt("return", (0, _ajax.formPost)(UPLOAD_DOCUMENT_V2, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(HELOC_CONTEXT_V2, "/document"), form, data, onProgress));

            case 6:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));

    return function (_x28) {
      return _ref29.apply(this, arguments);
    };
  }();
};
/**
 * @deprecated Sets the Plaid assets linked timestamp. See saveIncomeVerificationRequest
 */


exports.uploadDocumentV2 = uploadDocumentV2;

var setPlaidAssetsLinked = function setPlaidAssetsLinked(uuid) {
  return /*#__PURE__*/function () {
    var _ref30 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee29(dispatch) {
      return _regenerator.default.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              return _context29.abrupt("return", (0, _ajax.ajaxPut)(SET_PLAID_ASSETS_LINKED, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(uuid, "/plaid/accounts-linked")));

            case 1:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }));

    return function (_x29) {
      return _ref30.apply(this, arguments);
    };
  }();
};

exports.setPlaidAssetsLinked = setPlaidAssetsLinked;

var getHelocStates = function getHelocStates() {
  var dispatchHttpActions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return /*#__PURE__*/function () {
    var _ref31 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee30(dispatch) {
      var STATE_CONTEXT;
      return _regenerator.default.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              STATE_CONTEXT = _env.isMerchant ? '/app-merloc/external/api/v1/merloc' : '/service-application/external/heloc';
              (0, _ajax.ajaxGet)(GET_ELIGIBLE_STATES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(STATE_CONTEXT, "/states-eligibility"), null, null, dispatchHttpActions);

            case 2:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }));

    return function (_x30) {
      return _ref31.apply(this, arguments);
    };
  }();
};

exports.getHelocStates = getHelocStates;

var getIneligibleZipCodes = function getIneligibleZipCodes() {
  return /*#__PURE__*/function () {
    var _ref32 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee31(dispatch) {
      return _regenerator.default.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              return _context31.abrupt("return", (0, _ajax.ajaxGet)(GET_INELIGIBLE_ZIP_CODES, dispatch, "".concat((0, _httpActions.baseUrl)(), "/service-application/external/heloc/zip-eligibility")));

            case 1:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }));

    return function (_x31) {
      return _ref32.apply(this, arguments);
    };
  }();
};

exports.getIneligibleZipCodes = getIneligibleZipCodes;

var saveManualPaystubData = function saveManualPaystubData(data) {
  return /*#__PURE__*/function () {
    var _ref33 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee32(dispatch) {
      return _regenerator.default.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              return _context32.abrupt("return", (0, _ajax.ajaxPut)(SAVE_MANUAL_PAYSTUB_DATA, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/manual-paystub"), data));

            case 1:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32);
    }));

    return function (_x32) {
      return _ref33.apply(this, arguments);
    };
  }();
};

exports.saveManualPaystubData = saveManualPaystubData;

var giactAccountVerification = function giactAccountVerification(data) {
  return /*#__PURE__*/function () {
    var _ref34 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee33(dispatch) {
      return _regenerator.default.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              return _context33.abrupt("return", (0, _ajax.ajaxPut)(GIACT_ACCOUNT_VERIFICATION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/ach/giact"), data));

            case 1:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33);
    }));

    return function (_x33) {
      return _ref34.apply(this, arguments);
    };
  }();
};

exports.giactAccountVerification = giactAccountVerification;

var plCrossSell = function plCrossSell(data) {
  return /*#__PURE__*/function () {
    var _ref35 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee34(dispatch) {
      return _regenerator.default.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              return _context34.abrupt("return", (0, _ajax.ajaxPut)(PL_CROSS_SELL, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/pl-cross-sell"), data));

            case 1:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34);
    }));

    return function (_x34) {
      return _ref35.apply(this, arguments);
    };
  }();
};

exports.plCrossSell = plCrossSell;

var bypassIDVerification = function bypassIDVerification(_ref36) {
  var helocUuid = _ref36.helocUuid,
      _ref36$triggerEmail = _ref36.triggerEmail,
      triggerEmail = _ref36$triggerEmail === void 0 ? true : _ref36$triggerEmail;
  return /*#__PURE__*/function () {
    var _ref37 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee35(dispatch) {
      return _regenerator.default.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              return _context35.abrupt("return", (0, _ajax.ajaxPut)(BYPASS_ID_VERIFICATION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/id-bypass"), {
                helocUuid: helocUuid,
                triggerEmail: triggerEmail
              }));

            case 1:
            case "end":
              return _context35.stop();
          }
        }
      }, _callee35);
    }));

    return function (_x35) {
      return _ref37.apply(this, arguments);
    };
  }();
};

exports.bypassIDVerification = bypassIDVerification;

var sendEmployerVerification = function sendEmployerVerification(data) {
  return /*#__PURE__*/function () {
    var _ref38 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee36(dispatch) {
      return _regenerator.default.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              return _context36.abrupt("return", (0, _ajax.ajaxPut)(SEND_EMPLOYER_VERIFICATION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/employer-verification"), data));

            case 1:
            case "end":
              return _context36.stop();
          }
        }
      }, _callee36);
    }));

    return function (_x36) {
      return _ref38.apply(this, arguments);
    };
  }();
};

exports.sendEmployerVerification = sendEmployerVerification;

var confirmOffer = function confirmOffer(_ref39) {
  var helocUuid = _ref39.helocUuid,
      confirm = _ref39.confirm;
  return /*#__PURE__*/function () {
    var _ref40 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee37(dispatch) {
      return _regenerator.default.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              return _context37.abrupt("return", (0, _ajax.ajaxPut)(CONFIRM_OFFER, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/confirm-offer"), {
                helocUuid: helocUuid,
                confirm: confirm
              }));

            case 1:
            case "end":
              return _context37.stop();
          }
        }
      }, _callee37);
    }));

    return function (_x37) {
      return _ref40.apply(this, arguments);
    };
  }();
};

exports.confirmOffer = confirmOffer;